import { render } from "./AppDefault.vue?vue&type=template&id=547aacde"
const script = {}

import exportComponent from "/home/runner/work/adaptif-frontend/adaptif-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__